export default __webpack_public_path__ + "static/media/ripple.01e5a320.PNG";